export default __webpack_public_path__ + "ce6844f23275f5c18be05eca5348ca35.png";